import { render, staticRenderFns } from "./NewSubmission.vue?vue&type=template&id=7b2adb0d"
import script from "./NewSubmission.vue?vue&type=script&lang=js"
export * from "./NewSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports